import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';

const SimpleResourcePage = ({ title, description, path, eyebrow, message }) => (
  <>
    <SeoHead title={title} description={description} path={path} />
    <header className="page-header">
      <div className="container">
        <span className="section-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
    </header>
    <section className="section">
      <div className="container" style={{ textAlign: 'center' }}>
        <Link to="/contact" className="btn btn-accent">Talk to us <FiArrowRight /></Link>
      </div>
    </section>
  </>
);

export default SimpleResourcePage;
